import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import portinActivationActions from '../../../redux/portinActivation/actions';
import RefreshLineIcon from 'remixicon-react/RefreshLineIcon';

const InCompletePortinCount = () => {
    const dispatch = useDispatch();
    const { getIncompleteCount } = portinActivationActions;
    const { inCompletePortinCountResult, inCompletePortinCountLoading } = useSelector((state) => state.portinActivation);
    const [showBox, setShowBox] = useState(false);

    const fetchPendingCount = () => {
        dispatch(getIncompleteCount());
    };

    useEffect(() => {
        dispatch(getIncompleteCount());
    }, []);


    const portinInCompleteList = Array.isArray(inCompletePortinCountResult) ? inCompletePortinCountResult.filter(item =>
        item && item.BulkTransactionID) : inCompletePortinCountResult && inCompletePortinCountResult.BulkTransactionID ? [inCompletePortinCountResult] : [];

    return (
        <div className="row mb-2">
            <div className="col-12">
                <div className="d-flex align-items-center justify-content-between mb-1">
                    <div className="d-flex align-items-center">
                        <input type="checkbox" checked={showBox} onChange={() => setShowBox(prev => !prev)} style={{ marginRight: '6px', cursor: 'pointer' }} />
                        <h5 style={{ fontWeight: 800, marginBottom: 0 }}> Show Incomplete Portin Count </h5>
                    </div>

                    <RefreshLineIcon onClick={fetchPendingCount} style={{ cursor: 'pointer' }} size={18} color="#8b0303" title="Refresh" />
                </div>
                {showBox && (
                    <div
                        className="dpr-pending-box"
                        style={{ width: '100%', maxHeight: '300px', border: '1px solid #dee2e6', borderRadius: '6px', padding: '10px', overflowY: 'auto', background: '#f8f9fa' }}
                    >

                        {inCompletePortinCountLoading ? (
                            <div className="dashboard-inventory-loader" style={{ marginTop: '20px', textAlign: 'center' }} >
                                <span className="spinner-border spinner-border-lg" role="status" />
                            </div>
                        ) : portinInCompleteList.length > 0 ? (

                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', fontSize: '14px' }} >
                                {portinInCompleteList.map((item, index) => (
                                    <span key={index}>
                                        <span title={item?.BulkTransactionID || ''} style={{ color: '#2f2f2f', fontWeight: 500 }} > {item?.BulkTransactionID} </span>
                                        <span style={{ color: '#dc3545', fontWeight: 700, marginLeft: '4px' }} >{item?.InCompleteCount ?? 0}</span>
                                        {index !== portinInCompleteList.length - 1 && (<span style={{ color: 'black', fontWeight: '600' }}>,</span>)}
                                    </span>
                                ))}
                            </div>

                        ) : (
                            <p
                                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 0, color: '#8b0303', fontWeight: 600 }} >
                                No pending data found
                            </p>
                        )}
                    </div>
                )}

            </div>
        </div>

    );
};

export default InCompletePortinCount;
